module.exports = __webpack_public_path__ + "static/media/53_tn.44cd589b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/thumbnails/53_tn.jpg
// module id = 541
// module chunks = 0